// SEQ=10124 P8-CK-H — Merchant UX 오버레이
// 사양: SEQ-10119 §3-3 #9 + SEQ-10123 §1-2 #9
//   ── 본인 마을/도시 인접 hex 클릭 → 마커 이동
//   ── 클라 사전 집계: 본인 점유 vertex의 인접 hex 집합 (candidateHexIds)
//   ── 서버 SP 재검증 follow-up
export interface MerchantPlacementOverlayProps {
  /** 클라 사전 집계 후보 hex 집합 */
  candidateHexIds: number[]
  onCancel: () => void
}

export default function MerchantPlacementOverlay({
  candidateHexIds, onCancel,
}: MerchantPlacementOverlayProps) {
  return (
    <div style={overlay}>
      <div style={card}>
        <div style={title}>🛒 상인 (Merchant)</div>
        <div style={body}>
          <div>본인 <b>마을/도시 인접 hex</b>를 클릭해 상인 마커를 배치합니다.</div>
          <div style={hint}>후보 hex {candidateHexIds.length}개 (보드 highlight).</div>
          {candidateHexIds.length === 0 && (
            <div style={warn}>인접 hex가 없습니다. 취소하세요.</div>
          )}
        </div>
        <div style={footer}>
          <button onClick={onCancel} style={btnSec}>취소</button>
        </div>
      </div>
    </div>
  )
}

const overlay: React.CSSProperties = { position: 'fixed', top: 12, right: 12, zIndex: 950, pointerEvents: 'none' }
const card:    React.CSSProperties = { background: '#fff', border: '1px solid #888', borderRadius: 6, padding: 12, minWidth: 240, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', pointerEvents: 'auto' }
const title:   React.CSSProperties = { fontWeight: 'bold', marginBottom: 6, fontSize: 14 }
const body:    React.CSSProperties = { fontSize: 12 }
const hint:    React.CSSProperties = { fontSize: 11, color: '#666', marginTop: 4 }
const warn:    React.CSSProperties = { fontSize: 11, color: '#c00', marginTop: 4 }
const footer:  React.CSSProperties = { marginTop: 8, textAlign: 'right' }
const btnSec:  React.CSSProperties = { padding: '4px 10px', background: '#eee', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
